import Text from '../Text';
import { useTheme } from '@gogame/ui/styles';

export const TickText = ({ children, verticalAnchor, ...props }) => {
  const theme = useTheme();
  return (
    <Text
      className={'recharts-text recharts-cartesian-axis-tick-value'}
      intensity={200}
      fontSize={'10px'}
      vertical-anchor={verticalAnchor}
      {...props}
      fill={theme.palette.text.primary}
    >
      {children}
    </Text>
  );
};

export default TickText;
